module.exports = __webpack_public_path__ + "img/login-box-bg.959c4e38.svg";